import { render, staticRenderFns } from "./contract-assets-add.vue?vue&type=template&id=1d413942"
import script from "./contract-assets-add.vue?vue&type=script&lang=js"
export * from "./contract-assets-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports